import React, { Component } from 'react';
import {Label, DatePickerCalendar, StatusBadge, Switch} from 'app/components/Basics/';
import { Select } from '@ecosystem/ui-lib/core/components/Select';
import { Checkbox } from '@ecosystem/ui-lib/core/components/Checkbox';
import { Input as EcoInput } from '@ecosystem/ui-lib/core/components/Input';
import './GlobalFieldLineComponent.scss';
import {HoneypotSetFormContext} from '../../HoneypotSetContext';

class GlobalFieldLine extends Component {

    static contextType = HoneypotSetFormContext;

    constructor(props){
        super(props);        
    }

	setStartDate(date) {		
		var selectedHoneypotSet = this.context.selectedHoneypotSet;
		selectedHoneypotSet.startDate = date;		
		this.context.updateSelectedHoneypotSet(selectedHoneypotSet);
	}

	setEndDate(date) {
		var selectedHoneypotSet = this.context.selectedHoneypotSet;
		selectedHoneypotSet.endDate = date;
		this.context.updateSelectedHoneypotSet(selectedHoneypotSet);
	}	

	enabledSwitchHandler() {
		var selectedHoneypotSet = this.context.selectedHoneypotSet;
		selectedHoneypotSet.enabled = this.context.selectedHoneypotSet.enabled === 1 ? 0 : 1;
		this.context.updateSelectedHoneypotSet(selectedHoneypotSet);
	}	

	userCannotChangeData() {
		return !this.props.canChangeData;
	}

    render() {
        return (
			<div>
				<div className="GlobalFieldLineComponent form-row">
					<div className="form-row-left">
						<div className="field-survey-from">
							<Label>Start Date</Label>
							<DatePickerCalendar disabled={this.userCannotChangeData()} value={this.context.selectedHoneypotSet.startDate}  onChange={this.setStartDate.bind(this)} />
						</div>
						{/* <div className="field-survey-to">
							<Label>Survey To</Label>
							<DatePickerCalendar disabled={this.userCannotChangeData()} value={this.context.selectedHoneypotSet.endDate} minDate={this.context.selectedHoneypotSet.startDate} onChange={this.setEndDate.bind(this)} />
						</div> */}
						<div className="field-enabled">
							<Label>Enabled</Label>
							<div className="default-height centered"><Switch disabled={this.userCannotChangeData()} name="enabled" setSwitchValue={this.enabledSwitchHandler.bind(this)} checked={this.context.selectedHoneypotSet.enabled === 1}/></div>
						</div>						
					</div>
				</div>
			</div>
        );
    }
}

GlobalFieldLine.contextType = HoneypotSetFormContext;

export default GlobalFieldLine;